/**
 * Dock geometry.
 *
 * The absolute-coordinate maths that used to live here (stackPosition / clampToViewport /
 * readSavedPosition) is gone with the floating windows it served. Three rounds of fixing
 * those coordinates still left windows overlapping, stranded off the right edge, or
 * hanging below the fold, so the windows are now laid out by flexbox against the
 * bottom-right corner and cannot be positioned wrongly at all.
 *
 * 360px, not the old 420: three docked conversations fit a 1366-wide laptop, and the
 * header stops overflowing — which is what hid the Close button.
 */
export const DOCK_WINDOW_W = 360;

/** Gap between docked windows, and from the viewport edges. */
export const DOCK_GAP = 12;
export const DOCK_MARGIN = 16;
